import { current } from "@reduxjs/toolkit"
import { resetGame, setChoicesList, setIsGameCompleted } from "../reducers/gameZone"
import { setCurrentQuestion } from "../reducers/gameZone"
import { setSelectedParcours } from "../reducers/parcours"
import { store } from "../store/store"
import axios from "axios"
import { setNiveauProfile } from "../reducers/niveau"
import { setTechnologyProfile } from "../reducers/technologies"

const { PLAY_API_ROUTE, SEND_RESPONSE_API_ROUTE } = require("../../routes/api/api_routes")


const play = {
    getQuestion(quiz_profile_id,completed,tech_id,niveau_id){
        return new Promise((resolve,reject)=>{
            axios.post(`${PLAY_API_ROUTE}${quiz_profile_id}/${completed}/${tech_id}/${niveau_id}`,'',{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              })
            .then(response => {
                console.log(response);
                if(response.status === 200){
                    let dispatch = store.dispatch
                    let question = response.data.data.quizz.question
                    let reponses = response.data.data.quizz.reponses
                    dispatch(resetGame())
                    dispatch(setCurrentQuestion(question))
                    dispatch(setChoicesList(reponses))
                    /*dispatch(setNiveauProfile(niveau))
                    dispatch(setTechnologyProfile(tech))*/
                    resolve(response.status)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
    sendResponse(question_id,quiz_profile_id,response_id,completed){
        return new Promise((resolve,reject)=>{
            axios.post(`${SEND_RESPONSE_API_ROUTE}${question_id}/${quiz_profile_id}/${response_id}/${completed}`,'',{
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              })
            .then(response => {
                let dispatch = store.dispatch
                if(response?.data?.resultat?.completed){
                    console.log(response);
                    dispatch(setIsGameCompleted(response?.data?.resultat))
                }else if(response.status === 200){
                    let question = response.data.data.quizz.question
                    let reponses = response.data.data.quizz.reponses

                    dispatch(setCurrentQuestion(question))
                    dispatch(setChoicesList(reponses))
                    resolve(response.status)
                }else{
                    reject(response)
                }
            })
            .catch(err => {
                console.log(err);
                reject(err)
            })
        })
    },
}
export default play